<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="banner-box" id='home' ref="home">
      <div class="banner-text">
        <div class="title">FLEUSWORD：連接全球，引領數字未來</div>
        <!-- <div class="subtitle">副標題副標題副標題副標題副標題</div> -->
        <div class="text">FLEUSWORD是一家专业的海外数字营销公司，致力于为客户提供全球化的数字化解决方案。我们凭借先进的技术和深厚的行业经验，为企业打造独特的品牌形象，助力其在国际市场取得成功。通过全面的社交媒体运营管理服务，跨境数字营销策略定制以及数据分析与优化，我们帮助客户实现在全球范围内的品牌曝光和市场份额的提升。</div>
      </div>
    </div>
    <div class="user-serve-box">
      <div class="title">我們的服務</div>
      <!-- <div class="subtitle">副標題副標題副標題副標題副標題</div> -->
      <div class="server-list-box">
        <div class="server-box">
          <img src="../assets/img-1.png" alt="">
          <div class="s-title">全球化策略服務 </div>
          <div class="s-text">我們以全球視野為您量身打造數位行銷策略。 無論您的目標是跨越國界，還是在特定國家或地區拓展市場，我們的全球化策略服務將助您成功突破國際市場。 </div>
        </div>
        <div class="server-box">
          <img src="../assets/img-2.png" alt="">
          <div class="s-title">多通路數位推廣</div>
          <div class="s-text">- 透過我們的多通路數位推廣服務，您將在各大數位平台上展開全面性的宣傳活動。 我們利用尖端數位技術，確保您的品牌獲得最大的線上曝光和最高的轉換率。 </div>
        </div>
        <div class="server-box">
          <img src="../assets/img-3.png" alt="">
          <div class="s-title">資料驅動分析 </div>
          <div class="s-text"> - 我們以數據為基礎，透過深度分析客戶行為和市場趨勢，為您提供精準的數位行銷建議。 我們相信，透過數據的力量，您將更了解目標受眾並取得可持續的業務成功。 </div>
        </div>
        <div class="server-box">
          <img src="../assets/img-4.png" alt="">
          <div class="s-title">全面社群媒體管理</div>
          <div class="s-text">- 社群媒體是數位時代溝通的重要平台，我們提供全面的社群媒體管理服務，包括內容創作、社群媒體廣告和社群建立。 讓您的品牌在社群媒體上脫穎而出。 </div>
        </div>
        <div class="server-box">
          <img src="../assets/img-5.png" alt="">
          <div class="s-title">客製化內容創意</div>
          <div class="s-text">- 我們致力於為您提供獨特而引人入勝的內容。 無論是精美的圖像、引人注目的視頻，還是富有深度的博客，我們都以創意為核心，創造內容以打動您的目標受眾 </div>
        </div>
        <div class="server-box">
          <img src="../assets/img-6.png" alt="">
          <div class="s-title">持續優化與改進</div>
          <div class="s-text">- 數位行銷是不斷演變的領域，我們不僅幫助您制定初始策略，更致力於持續優化和改進。 透過不斷監控和回饋，我們確保您的數位行銷策略始終保持最佳狀態，並應對市場變化。 </div>
        </div>
      </div>
    </div>

    <div class="business-box">
      <div class="business-text">
        <div class="business-title">選擇我們</div>
        <div class="b-text">
          公司以“專注科技，用心服務”為核心價值，全面分析企業發展的內部和外部環境，客觀審視自身戰略取勢和定位，正確評價自身條件和能力，優化資源配置，立足於專業化和特色化發展，充分發揮優勢，規避風險，抓住機遇，採取積極果斷行動搶占先機。
          <br> 高效率：通過高科技系統的使用，迅速提升整個投放過程的效率，堅決落實投放時間。
          <br> 高品質：我們所有的廣告投放都有極其嚴格的控制流程，通過實時反饋和長期歷史記錄，實現出海企業廣告投放過程任何問題的準確傳遞和及時處理，確保出品必屬精品。
          <br> 高服務：我們從創立起始終致力於為客戶提供最及時最專業的服務，售前售後為您提供一切專業性服務。
        </div>
      </div>
    </div>

    <div class="partner-box">
      <div class="p-title">全球戰略合作夥伴</div>
      <div class="p-subtitle">我們致力於通過打造屬於出海企業科技技術服務公司，培育更多的廣告投放市場，按規劃憑藉更高效率和效能研發可觸達市場。 </div>
      <div class="partner-list">
        <img src="../assets/icon-1.png" alt="">
        <img src="../assets/icon-2.png" alt="">
        <img src="../assets/icon-3.png" alt="">
        <img src="../assets/icon-4.png" alt="">
        <img src="../assets/icon-5.png" alt="">
        <img src="../assets/icon-6.png" alt="">
      </div>
    </div>

    <div class="privacy-box">
      <div class="pr-title">隱私政策</div>
      <div class="privacy-text">
        請仔細閱讀本政策。訪問本網站即表示您認可並同意本政策中所述的做法，需要您特定許可的地方除外。本隱私政策以及本網站上可能不時更新的法律聲明描述了我們如何收集、使用和披露通過本網站或在我們業務活動過程中收集的個人和非個人信息。
        <br> 根據適用的數據保護法，我們將負責控製本網站上從您處收集的個人信息，或者與您一起開展或發展我們的業務。
        <p>我們自動收集的信息</p>

        <br> 當您訪問本網站時，我們的服務器會自動收集某些瀏覽器或設備生成的信息，包括但不限於：
        <br> ·域名； 
        <br> ·IP地址；
        <br> ·您訪問的日期、時間和持續時間；
        <br> ·瀏覽器類型；
        <br> ·操作系統；
        <br> ·頁面訪問情況。
        <br> 我們不會使用此自動收集的信息來嘗試識別您的身份，但我們可能會將其與您自願提供的信息相關聯，詳見下文。
        <p>您提供的信息</p>

        <br> 在使用本網站與我們開展業務或尋求與我們開展業務時，您可以通過以下方式自願向我們提供個人信息：
        <br> ·通過在我們的網站上或在廣告宣傳著陸頁上或在任何其他我們開展業務的地方填寫表格（如“聯繫我們”表格）；
        <br> ·通過訂閱電子報或其他信息；
        <br> ·通過電話、電子郵件或我們的其他聯繫方式與我們聯繫；
        <br> ·或通過申請工作、工作安排或實習。 
        <br> 通常，您提供給我們的個人信息可能包括姓名、公司名稱、地址、電子郵件地址、電話號碼以及任何其他用以解決疑問或投訴的個人信息。與您簽訂合同時將需要這些信息（例如服務合同或購買協議或提供諸如從我們網站下載信息等服務）。如果沒有提供這些信息，則可能導致我們無法為您提供所需的服務或產品申請。 

        <p>個人信息的使用</p>

        <br> 以下概述了我們使用您個人信息的目的。請注意，有關我們如何處理您個人信息的其他詳細信息可能會通過單獨的通知或合同提供給您。 
        <br>  所有您個人信息的處理過程（即使用）都符合處理“條件”。在大多數情況下，合法處理的依據是： 
        <br> ·您已經同意處理；
        <br> ·與您簽訂合同或簽訂合同的步驟需要進行處理；
        <br> ·依據相關法律我們必須進行處理；或
        <br> ·在不會觸犯您利益和基本權利的前提下，基於我們的合法權益，特別是我們使用供應商、客戶和網站用戶數據與他們以及他人開展和發展我們業務活動的合法權益進行處理。 
        <p>我們使用我們收集的個人信息來：</p>
        <br> ·與您和他人一起開展和發展我們的業務；
        <br> ·改進我們的網站，以及我們的產品和服務；
        <br> ·根據用戶需求定制我們的網站；
        <br> ·為您提供您所要求的文件或信息；
        <br> ·與用戶交流以解決他們的疑問或投訴；
        <br> ·為您提供您所要求的任何服務或產品；
        <br> 如果允許，向您發送營銷信息。 
        <br>  
        <br> 營銷、短信和電子郵件
        <br> 在合法且事先徵得您同意的前提下，我們可能會通過短信和電子郵件與您聯繫，向您介紹我們的產品和服務。如果您想退訂此類營銷信息，請使用我們在電子郵件中提供的“取消訂閱”鏈接，或通過網站中標註的聯繫方式直接與我們聯繫，我們將停止向您發送此類信息。
        <br> 為營銷目的進行分析
        <br> 分析的目的是為了向您提供與貴公司具有高度相關性或適用性的網站內容或電子郵件內容。為此，我們使用您以及數據增強服務第三方提供的信息，嘗試和識別貴公司的SIC行業代碼和其他重要信息。此外，我們還會根據您在我們網站上的訪問模式（我們自動收集的信息）以及對我們的電子郵件（您提供的信息）的回复，嘗試並確定貴公司可能感興趣的產品和應用。根據這些信息，我們將調整電子郵件內容和潛在的網站內容，以更好地匹配貴公司的要求和興趣。所述的處理過程以我們的合法利益為基礎。
        <br> 安全
        <br> 我們使用數據存儲和安全技術來保護您的個人信息免遭未經授權的訪問、濫用或洩露、未經授權的修改或非法破壞或意外丟失。但請注意，沒有任何網站能夠確保100％安全，我們不對超出我們控制範圍的未經授權或意外訪問承擔負責。
        <br> 保留您的信息
        <br> 我們實施保留個人信息的一般規則，在達到收集數據的目的之後，我們不會繼續保留個人信息。但在某些情況下（如根據法律、稅務和會計要求），我們可能會對個人信息保留更長時間。
        <br> 在特定情況下，我們也可能會對您的個人信息保留更長的時間，以便在發生投訴或出現問題時我們有您與我們交易的準確記錄。
        <p>您的權利</p>
        <br> 根據適用法律，您可能擁有以下部分或全部涉及您個人信息的權利：
        <br> ·獲取您個人信息的副本，以及有關如何以及以什麼為基礎處理個人信息的信息；
        <br> ·糾正不准確的個人信息（包括完成不完整個人信息的權利）； 
        <br> ·刪除您的個人信息（在就其收集或處理目的而言不再需要的有限情況下）； 
        <br> ·在以下情況下限制處理您的個人信息： 
        <br> ·個人信息的準確性受到質疑；
        <br> ·處理不合法，但您反對刪除個人信息；
        <br> ·我們不再需要個人信息，但仍需要它來提出、行使或辯護法律索賠；
        <br> ·當我們在徵得您同意的前提下或為履行與您簽訂的合同合法處理您的數據時，將數據以機器可讀的格式存入第三方（或您處）；
        <br> ·撤銷您對我們處理您個人信息的同意（在處理需要徵得您同意的情況下）；
        <br> ·反對僅基於自動處理或分析的決策；
        <br> ·獲取或查看針對將您的個人信息轉移給第三國或國際組織所採取的適當保護措施的副本。
        <br> 除上述權利外，您有權反對我們基於合法利益對您的信息進行處理，包括（與您的同意相背，或為了與您簽訂合同）進行分析。您也有權反對我們為實現直接營銷目的對您的信息進行處理，包括針對營銷目的進行分析。 
        <br>
        <br> 您也有權向當地監管機構提出有關保護數據的投訴。 
        <br> 關於所有這些權利，請使用頁面上部的“聯繫我們”鏈接聯繫我們。請注意，我們可能會要求提供身份證明，我們保留在法律允許的情況下收取費用的權利，例如，如果您的請求明顯毫無依據或您提出過度要求。我們將盡力在所有適用的時間範圍內回應您的請求。 
        <br> 聯繫信息
        <br> 如果您對本政策有任何疑問或者您想行使您的任何權利，請點擊此處提交您的請求。



      </div>

    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.banner-box {
  background-image: url(../assets/swiper-1.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    // margin-top: 165px;
    margin-left: 360px;
    padding-top: 165px;
    width: 682px;

    .title {
      font-size: 64px;
      font-weight: 500;
      color: #333333;
    }

    .subtitle {
      font-size: 26px;
      font-weight: 500;
      color: #333333;
    }

    .text {
      font-size: 28px;
      font-weight: 400;
      color: #999999;
      margin-top: 24px;
    }
  }
}

.user-serve-box {
  margin-top: 120px;

  .title {
    font-size: 48px;
    text-align: center;
    font-weight: 500;
    color: #333333;
  }

  .subtitle {
    font-size: 26px;
    margin-top: 24px;
    text-align: center;
    font-weight: 500;
    color: #999999;
  }

  .server-list-box {
    margin-top: 34px;
    display: flex;
    align-items: center;
    padding: 0px 360px;
    flex-wrap: wrap;
    justify-content: space-between;

    .server-box {
      margin-top: 30px;
      width: 300px;
      height: 306px;
      background: #FFFFFF;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      border: 1px solid #EBEBEB;
      padding: 40px;

      img {
        width: 72px;
        height: 72px;
      }

      .s-title {
        font-size: 20px;
        margin-top: 16px;
        font-weight: 600;
        color: #333333;
      }

      .s-text {
        font-size: 20px;
        margin-top: 16px;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}

.business-box {
  background-image: url(../assets/swiper-2.png);
  width: 100%;
  height: 900px;
  background-size: 100% 100%;
  position: relative;

  .business-text {
    padding-top: 185px;
    margin-left: 960px;
    width: 900px;

    .business-title {
      font-size: 48px;
      font-weight: 500;
      color: #333333;
    }

    .b-text {
      font-size: 28px;
      margin-top: 24px;
      font-weight: 400;
      color: #999999;
    }
  }
}

.partner-box {
  padding: 119px 360px;
  margin-top: 80px;
  text-align: center;

  .p-title {
    font-size: 48px;
    font-weight: 500;
    color: #333333;
  }

  .p-subtitle {
    font-size: 26px;
    margin-top: 24px;
    font-weight: 500;
    color: #999999;
  }

  .partner-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 70px;

    img {
      width: 182px;
      height: 79px;
    }
  }
}

.privacy-box {
  background: url(../assets/privacy-bg.png);
  // width: 100%;
  height: 1094px;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .pr-title {
    padding-top: 120px;
    font-size: 48px;
    text-align: center;
    font-weight: 500;
    color: #333333;
  }

  .privacy-text {
    width: 1060px;
    height: 666px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 40px;
    overflow-y: scroll;
    font-size: 18px;
    font-weight: 400;
    color: #999999;
    padding: 40px;

    p {
      color: #333333;
      font-weight: bolder;
      margin-top: 50px;
    }
  }
}
</style>
